/* eslint-disable import/no-extraneous-dependencies */
import { configureStore } from '@reduxjs/toolkit';
import { applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import authentication from './reducers/auth.reducers';
import department from './reducers/department.reducers';
import global from './reducers/global.reducers';
import uom from './reducers/uom.reducers';
import currency from './reducers/currency.reducers';
import client from './reducers/client.reducers';
import rolePermission from './reducers/rolePermission.reducers';
import user from './reducers/user.reducers';
import audit from './reducers/audit.reducers';
import company from './reducers/company.reducers';
import payment from './reducers/payment.reducers';
import setting from './reducers/setting.reducers';
import dashboard from './reducers/dashboard.reducers';
import report from './reducers/report.reducers';

export const rootReducer = {
  authentication,
  department,
  global,
  uom,
  currency,
  client,
  rolePermission,
  user,
  audit,
  company,
  payment,
  setting,
  dashboard,
  report
};
export const store = configureStore({ reducer: rootReducer }, applyMiddleware(thunkMiddleware));
